module.exports = __webpack_public_path__ + "static/media/kz.7236d4e4.svg";